import { createFileRoute } from '@tanstack/react-router';
import { PlanWizard } from '@/features/planner/PlanWizard.tsx';
import { requireAuth } from '@/features/auth/guard.ts';

export const Route = createFileRoute('/_app/plan')({
  validateSearch: (s: Record<string, unknown>): { city?: string } => (typeof s.city === 'string' ? { city: s.city } : {}),
  beforeLoad: requireAuth,
  component: PlanRoute,
});

function PlanRoute() {
  const { city } = Route.useSearch();
  return <PlanWizard presetCity={city} />;
}
